import React, { useState } from 'react';
import { Button } from 'antd';
import { ReloadOutlined, EditOutlined, CodeOutlined } from '@ant-design/icons';

function classifyError(msg) {
  const m = (msg || '').toLowerCase();
  if (/permission|denied|unauthorized|forbidden/.test(m))
    return { headline: "You don't have access to this data", hint: 'Ask the dataset owner for access, or pick a different schema.' };
  if (/timeout|deadline/.test(m))
    return { headline: 'The query took too long to complete', hint: 'Try narrowing the date range or adding a LIMIT.' };
  if (/column .* (does not exist|not found|unknown)/i.test(msg) || /no such column/.test(m))
    return { headline: 'A column referenced in the query is missing', hint: 'Likely a typo or a renamed column — open the SQL to fix it.' };
  if (/syntax error|unexpected token/.test(m))
    return { headline: "There's a syntax error in the SQL", hint: 'Open the SQL to see the error position.' };
  if (/network|fetch|failed to/.test(m))
    return { headline: 'Could not reach the data service', hint: 'Check your connection or try again in a moment.' };
  return { headline: "Couldn't load this data", hint: null };
}

export default function ErrorPanel({
  message,
  onRetry,
  onEditQuery,
  onShowSql,
  compact = false,
}) {
  const [showFull, setShowFull] = useState(false);
  const { headline, hint } = classifyError(message);
  return (
    <div className="dx-error" style={compact ? { padding: 12 } : undefined}>
      <div className="dx-error-icon">!</div>
      <div className="dx-error-title">{headline}</div>
      {hint && <div className="dx-error-detail">{hint}</div>}
      {message && (
        <div className="dx-error-detail" style={{ wordBreak: 'break-word' }}>
          {showFull ? (
            <code style={{ whiteSpace: 'pre-wrap' }}>{message}</code>
          ) : (
            <code>{String(message).slice(0, 140)}{String(message).length > 140 ? '…' : ''}</code>
          )}
        </div>
      )}
      <div className="dx-error-actions">
        {onRetry && (
          <Button size="small" type="primary" icon={<ReloadOutlined />} onClick={onRetry}>Retry</Button>
        )}
        {onEditQuery && (
          <Button size="small" icon={<EditOutlined />} onClick={onEditQuery}>Edit query</Button>
        )}
        {onShowSql && (
          <Button size="small" type="text" icon={<CodeOutlined />} onClick={onShowSql}>Show SQL</Button>
        )}
        {message && String(message).length > 140 && (
          <Button size="small" type="text" onClick={() => setShowFull(v => !v)}>
            {showFull ? 'Hide details' : 'Show details'}
          </Button>
        )}
      </div>
    </div>
  );
}
